import {ApprovalStatusType, CurrentTxnStatus} from "@app/shared";

export class AtRiskRequest {
  id?: number;
  version?: number;

  contractId?: number;
  clinId?: number;
  projectId?: number;

  authorizedValue: number;
  effectiveFrom: string;
  effectiveThru: string;
  justification: string;

  overridePercentageCompletion: number;
  overrideCompletion: boolean;

  // approvable
  submittedById: number;
  submittedForId: number;
  submittedOn: Date;
  currentStatusName: ApprovalStatusType;

  // Transient
  contractTitle: string;
  clinName: string;
  projectNumber: string;
  projectName: string;
}
